import React, { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { Form, Input, Button, message, Skeleton } from 'antd'; // Import Antd components
// The import for the Ant Design CSS has been changed.
// We're now importing the default CSS file directly from the antd package.
import 'antd/dist/reset.css'; // Import Antd styles
import { getRequest, putRequest } from '../../../helpers/apiCall';

const { TextArea } = Input;

const ExpertInfo = () => {
  const { id } = useParams();
  const location = useLocation();
  const { expert } = location.state || {};
  const [form] = Form.useForm();
  const [loading, setLoading] = React.useState(false);
  const onFinish = async values => {
    try {
      setLoading(true);
      const resp = await putRequest('add-expert-info', {
        expert_id: id,
        expert_info: values.message,
      });
      if (resp?.data?.success) {
        message.success(resp.data.message);
      } else {
        message.error(resp.data.message);
      }
      setLoading(false);
      getExpertInfo();
    } catch (error) {
      message.error(error.message);
      setLoading(false);
    }
  };
  async function getExpertInfo() {
    try {
      setLoading(true);
      const resp = await getRequest('get-expert-info?expert_id=' + id);
      if (resp?.data?.success) {
        form.setFieldsValue({ message: resp?.data?.data });
      }
      setLoading(false);
    } catch (error) {
      message.error(error.message);
    }
  }
  useEffect(() => {
    getExpertInfo();
  }, []);
  return (
    <div className="bg-gray-100 min-h-screen flex items-center justify-center p-4 font-sans">
      <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-lg">
        {/* Display the expert ID retrieved from the URL */}
        <h1 className="text-2xl font-bold mb-6 text-center text-gray-800">
          {expert?.first_name && expert?.last_name
            ? `${expert?.first_name} ${expert?.last_name}`
            : 'Expert'}
          {' Information'}
        </h1>
        {
          <>
            <Form
              form={form}
              name="expert-message-form"
              onFinish={onFinish}
              layout="vertical"
              autoComplete="off"
            >
              {/* Form item for the text area field */}
              <Form.Item
                name="message"
                label="Expert's Information"
                rules={[
                  {
                    required: true,
                    message: 'Please enter expert information!',
                  },
                ]}
              >
                {loading ? (
                  <>
                    <Skeleton active />
                  </>
                ) : (
                  <TextArea rows={4} placeholder="Type your message here..." />
                )}
              </Form.Item>

              {/* Form item for the submit button */}
              <Form.Item className="mt-6">
                <Button
                  loading={loading}
                  disabled={loading}
                  type="primary"
                  htmlType="submit"
                  className="w-full bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-300 transition-colors"
                >
                  Submit
                </Button>
              </Form.Item>
            </Form>
          </>
        }
        {/* The Ant Design Form component */}
      </div>
    </div>
  );
};

export default ExpertInfo;
